import Mosaic from './Mosaic';
import DestacatBasic from 'components/corporatiu/Destacat/DestacatBasic/DestacatBasic';
import DestacatIdioma from 'components/corporatiu/Destacat/DestacatIdioma/DestacatIdioma';

const MosaicDestacats = (props) => {
    const {
        items = [],
        hGap = 200,
        vGap = 200,
        numColumns = 2,
        numColumnsMobile = 1,
        formatDestacat = 'vertical',
        inici = 0,
        elements,
        mostrarData,
        mostraRanking,
        mostrarAvantitol,
        routePath,
        mostrarBotoMesItems,
        urlCarregaDinamica,
        totalPagines,
        estil,
        tema,
        titol,
        icona,
        idioma,
        numColumnsRow = 12,
        tipusImatge = 'web_destacat',
        objectFit
    } = props;

    const colWidth = Math.round(numColumnsRow / numColumns);
    const elementsAMostrar = elements || (items ? items.length - inici : 0);
    const itemsToShow = items?.slice(inici, inici + elementsAMostrar);
    const mostraData = mostrarData !== undefined ? mostrarData : true;
    return (
        <>
            {itemsToShow && (
                <div>
                    <Mosaic
                        numColumns={numColumns}
                        numColumnsMobile={numColumnsMobile}
                        hGap={hGap}
                        vGap={vGap}
                        tipus='corporatiu'
                        mostrarBotoMesItems={mostrarBotoMesItems}
                        urlCarregaDinamica={urlCarregaDinamica}
                        totalPagines={totalPagines}
                        titol={titol}
                        items={items}
                        estilMosaic={estil}
                        mostraRanking={mostraRanking}
                        numColumnsRow={numColumnsRow}
                        tipusImatge={tipusImatge}
                        icona={icona}
                    >
                        {itemsToShow?.map((item, index) =>
                            idioma ? (
                                <DestacatIdioma
                                    key={`destacat-premsa-${index}`}
                                    item={item}
                                    routePath={routePath}
                                    estil={estil}
                                    tema={tema}
                                    lang={idioma}
                                    mostrarAvantitol={mostrarAvantitol}
                                    mostrarImatge='true'
                                    numColumnsRow={colWidth}
                                />
                            ) : (
                                <DestacatBasic
                                    key={`destacat-premsa-${index}`}
                                    item={item}
                                    disposicio={formatDestacat}
                                    routePath={routePath}
                                    estil={estil}
                                    tema={tema}
                                    icona={icona}
                                    mostrarData={mostraData}
                                    mostrarAvantitol={mostrarAvantitol}
                                    mostrarImatge='true'
                                    numColumnsRow={colWidth}
                                    tipusImatge={tipusImatge}
                                    objectFit={objectFit}
                                    imatgeSrc={item?.imatgeSrc}
                                />
                            )
                        )}
                    </Mosaic>
                </div>
            )}
        </>
    );
};

export default MosaicDestacats;
